import { render } from "./footer.vue?vue&type=template&id=4c530924"
const script = {}

import exportComponent from "/var/www/local_dev/web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__